import { render, staticRenderFns } from "./advisor-comment.vue?vue&type=template&id=a99355ce&"
import script from "./advisor-comment.vue?vue&type=script&lang=js&"
export * from "./advisor-comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports